<template>
    <rkm-layout-body title="Lista de plantão">
        <template v-slot:actions>
            <rkm-button
                @click="$refs.Modal.open()"
                color="primary"
                authorize="store-pronto-atendimento-plantao"
            >
                Cadastrar plantão
            </rkm-button>
        </template>

        <rkm-overlay>
            <rkm-layout-content>
                <List
                    ref="List"
                    @click-to-update="$refs.Modal.open($event)"
                />
            </rkm-layout-content>

            <Modal
                ref="Modal"
                @save="handleSave"
            />
        </rkm-overlay>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/pronto-atendimento/plantao/List'
import Modal from '@/components/pronto-atendimento/plantao/Modal'

export default {
    components: { List, Modal },
    methods: {
        handleSave(_, updated) {

            if (updated) {

                this.$refs.List.search()
            }
        }
    }
}
</script>